/**
 * The displayed time zone as a UTC offset (`UTC-3`, `UTC+5:30`, `UTC`), computed from the IANA
 * zone with `Intl` so daylight saving is respected for the given instant.
 */
export function formatUtcOffset(timeZone: string, at: Date, locale: string): string {
  const part = new Intl.DateTimeFormat(locale, { timeZone, timeZoneName: "shortOffset" })
    .formatToParts(at)
    .find((p) => p.type === "timeZoneName")?.value;
  if (!part) return "UTC";
  const offset = part.replace(/^GMT/, "UTC");
  return /^UTC[+-]0(:00)?$/.test(offset) ? "UTC" : offset;
}
